const REGULAR_FLOW_SCREEN_NAMES = {
  personalDetails: 'Signup: Personal Details',
  siteDetails: 'Signup: Site Details',
  displayDuplicates: 'Signup: Display Duplicate Sites',
  contactModal: 'Signup: Duplicate site contact modal',
  submit: 'Signup: Submit',
  confirmation: 'Signup: Confirm',
};

const INVITE_FLOW_SCREEN_NAMES = {
  personalDetails: 'Inviter: Personal Details',
  siteDetails: 'Inviter: Site Details',
  displayDuplicates: 'Inviter: Display Duplicate Sites',
  contactModal: 'Inviter: Duplicate site contact modal',
  confirmation: 'Inviter: Confirm',
};

export { REGULAR_FLOW_SCREEN_NAMES, INVITE_FLOW_SCREEN_NAMES };
